export const processorsTypes = {
	TSYS: "tsys",
	FISERV_OMAHA: "fiserv_omaha",
	FISERV_NORTH: "fiserv_north",
	OTHER: "other",
};

export const processors = [
	{ value: processorsTypes.TSYS, name: "TSYS" },
	{ value: processorsTypes.FISERV_OMAHA, name: "Fiserv Omaha" },
	{ value: processorsTypes.FISERV_NORTH, name: "Fiserv North" },
	{ value: processorsTypes.OTHER, name: "Other" },
];

export const checkIsRetailSponsor = sponsor => {
	return sponsor && [0, 1].includes(sponsor.type);
};

export const checkIsWholeSaleSponsor = processor => {
	return processor && !checkIsRetailSponsor(processor);
};
